import { updateRoomAsyncResponse } from "./types";
import * as roomActions from "./rooms.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiPut, API_URL_ROOM, retrieveToken } from "../../../helpers/api";

export function* updateRooms(action: ReturnType<typeof roomActions.updateRoomAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    if (action.payload.id) {
      const result: Response = yield call(apiPut, API_URL_ROOM.UPDATE_ROOM(action.payload.id), token, action.payload);
      if (result.status === 200) {
        const parsed: updateRoomAsyncResponse = yield call(result.json.bind(result));
        yield put(roomActions.updateRoomAsync.success(parsed));
        return;
      } else {
        const parsed: ErrorResponse = yield call(result.json.bind(result));
        yield put(roomActions.updateRoomAsync.failure(parsed));
        return;
      }
    } else {
      const parsed: ErrorResponse = {
        status: 500,
        errors: {},
        message: 'Terjadi kesalahan pada server'
      }
      yield put(roomActions.updateRoomAsync.failure(parsed));  
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(roomActions.updateRoomAsync.failure(parsed));
  }
}

export default function* roomsSagaUpdateRoom() {
  yield takeEvery(roomActions.updateRoomAsync.request, updateRooms);
}
